import { render, staticRenderFns } from "./SingleView.vue?vue&type=template&id=3781c98a&scoped=true&"
import script from "./SingleView.vue?vue&type=script&lang=js&"
export * from "./SingleView.vue?vue&type=script&lang=js&"
import style0 from "./SingleView.vue?vue&type=style&index=0&id=3781c98a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3781c98a",
  null
  
)

export default component.exports